import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreSimpleStepItems } from "../../api/apiSimpleStepItems";
import parseError from "../../utils/parseError";

export function useRestoreAllSimpleStepItems() {
    const queryClient = useQueryClient();

    const { mutate: restoreAllItemsMutate, isPending } = useMutation({
        mutationFn: massRestoreSimpleStepItems,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["simple-step-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore items");
        },
    });

    return { restoreAllItemsMutate, isPending };
}
